import { render, staticRenderFns } from "./zuheShangpin_add.vue?vue&type=template&id=cfa60bea&scoped=true"
import script from "./zuheShangpin_add.vue?vue&type=script&lang=js"
export * from "./zuheShangpin_add.vue?vue&type=script&lang=js"
import style0 from "./zuheShangpin_add.vue?vue&type=style&index=0&id=cfa60bea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa60bea",
  null
  
)

export default component.exports